import { colors } from '@utils/tailwind';

export const LoginScreenView = {
  backgroundColor: colors.white,
  paddingTop: 0
};
